import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';

export const PageFallbackHeader = () => {
  return (
    <Box
      display="flex"
      justifyContent="end"
      height={65}
      gap="16"
      position="sticky"
      p="12"
      pr="40"
      zIndex={1200}
      top={0}
      borderColor="stroke.primary"
      borderBottom={1}
    >
      <Skeleton variant="rect" width={224} height={40} />
      <Skeleton variant="rect" width={40} height={40} />
      <Skeleton variant="circle" width={40} height={40} />
    </Box>
  );
};
